import { useNavigation } from '@react-navigation/core';
import { theme } from 'aimo-ui';
import { CardItem } from 'components/services';
import AccountContext from 'context/AccountContext';
import { useAimoPlusEligibility } from 'hooks/useAimoPlusEligibility';
import useIsLoggedIn from 'hooks/useIsLoggedIn';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useUiStore } from 'stores/uiStore';
import { StyledImage } from 'styles/ContainerStyles';
import { RootNavProps } from 'types/navigation';
import { MenuSection } from '../menuItems/MenuComponents';

const SubImage = ({ testID }: { testID?: string }) => (
  <StyledImage
    source={require('assets/images/aimo-plus.png')}
    width={97}
    height={97}
    center
    testID={testID}
  />
);

const Content = () => {
  const { navigate } = useNavigation<RootNavProps>();
  const { t } = useTranslation();
  const onPress = () => {
    navigate('mainTabs', {
      screen: 'accountScreen',
      params: { screen: 'aimoSubscription' },
    });
    useUiStore.getState().setSheetModal('');
  };
  return (
    <CardItem
      title={t('account.aimoSubscription.promotionTitle')}
      text={t('account.aimoSubscription.promotionDescription')}
      showPill={true}
      pillText={t('account.aimoSubscription.promotionPillText')}
      bgColor={theme.colors.lightBg.red}
      imageContainer={SubImage}
      onPress={onPress}
      countryToShow={['FI', 'SE']}
      testID="aimoplus-card"
    />
  );
};

const SubPromotionCard = ({ isMenuItem }: { isMenuItem?: boolean }) => {
  const { customer } = useContext(AccountContext);
  const { isLoggedIn } = useIsLoggedIn();
  const { isEligible, loading } = useAimoPlusEligibility({
    isLoggedIn,
    aimoPlusSubscriber: !!customer.aimoPlusSubscriber,
  });

  if (loading || !isEligible) {
    return null;
  }

  if (isMenuItem) {
    return (
      <MenuSection noDivider>
        <Content />
      </MenuSection>
    );
  }

  return <Content />;
};

export default SubPromotionCard;
